import { ref } from 'vue'
import { defineStore } from 'pinia'
import axios from '@/plugins/axios.js';
import i18n from 'i18next';
import { useRoute } from 'vue-router';

export const generalStore = defineStore('store', () => {
  let isMovil = ref(false);
  let isLive = ref(false)
  let isPP = ref(true);
  let alertMsg = ref('');
  let alertType = ref('');
  let alertState = ref('inactive-alert');
  let submenu = ref();
  let indexSup = ref(false);
  let load = ref(true);
  let config = ref([]);
  let route = useRoute();
  let regexpText = /[a-zA-Z]/
  let regexpNum = /\d/

  var dark = ref(false)
  var filterC = ref(false);
  var filterN = ref(false);
  var notFound = ref(false);
  var dataFiltered = ref([]);
  const SMS_URL = import.meta.env.VITE_URL_SMS;
  const STORAGE_URL = import.meta.env.VITE_STORAGE_URL;

  (function () {

    if ('serviceWorker' in navigator) {
      console.log('Worker')
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister();
        }
      }).catch(function (error) {
        console.log('Error al desregistrar el service worker:', error);
      });
    }

    if ('caches' in window) {
      console.log('cache')
      caches.keys().then(function(cacheNames) {
          cacheNames.forEach(function(cacheName) {
              caches.delete(cacheName);  // Borra cada caché
          });
      });
  }  

    if (window.innerWidth < 768) {
      isMovil.value = true
    }
  })();

  /*UTILIDAD VARIA */
  const setIsPP = (value) => {
    isPP.value = value
    setLocalStorage('isPP', isPP.value)
  }

  if (isMovil.value) {
    i18n.changeLanguage(window.navigator.language || navigator.browserLanguage)
  }

  if (window.matchMedia('(prefers-color-scheme: light)').matches) {
    dark.value = false
    document.documentElement.classList.remove('dark');
    localStorage.setItem('color-theme', 'light')
  } else {
    dark.value = true;
    document.documentElement.classList.add('dark');
    localStorage.setItem('color-theme', 'dark')
  }

  const darkMode = () => {
    dark.value = !dark.value;
    dark.value ? localStorage.setItem('color-theme', 'dark') : localStorage.setItem('color-theme', 'light')
    dark.value ? document.documentElement.classList.add('dark') : document.documentElement.classList.remove('dark');
  }

  const langFunction = (lng) => {
    i18n.changeLanguage(lng);
    window.location.reload();
  }

  const getIsPP = () => {
    return isPP.value;
  }

  const validChar = (char) => {
    return regexpText.test(char)
  }

  const validNum = (char) => {
    return regexpNum.test(char)
  }

  const setFiltered = (data) => {
    dataFiltered.value = data;
  }

  const getFiltered = () => {
    return dataFiltered.value;
  }

  const getIsLive = () => {
    return isLive.value;
  }

  const setIsLive = (value) => {
    isLive.value = value
  }

  const getLng = () => {
    return i18n.language
  }

  const getIndexSup = () => {
    return indexSup.value;
  }

  const setConfig = (data) => {
    config.value = data;
  }

  const getConfig = () => {
    return config.value;
  }

  /**
   * Function used to return date today in Json format
   * @returns day and month in json format
   */
  const getToday = () => {
    const today = new Date();
    var lng = getLng().split('-');
    return {
      "day": (today.toLocaleDateString((lng[0] + '-ES'), { weekday: 'long' })).toLowerCase(),
      "month": (today.toLocaleDateString((lng[0] + '-ES'), { month: '2-digit' })).toLowerCase()
    }
  }

  /**
   * Function used to filter data and return filtered data
   * @param {*} data contain data array to filter 
   * @param {*} type Type to filter data (Category or Name)
   * @param {*} filter Value to filter data
   */
  const filterData = async (name, cat, filter) => {
    dataFiltered.value = [];
    var tmp = ref([]);
    var url = route.name == 'News' ? '/news.php' : '/products.php';
    load = true;
    try {
      await axios.get(url, {
        params: {
          type: 'specific',
          name,
          cat,
          filter
        }
      }, {
      }).then(response => {
        if (response.status == 200) {
          tmp.value = (response['data']);
          if (tmp.value.length > 0) {
            notFound.value = false;
            setSessionStorage('persistSearch', {
              name,
              cat
            })
            switch (filter) {
              case 'Cat':
                filterC.value = true;
                break;
              case 'Name':
                filterN.value = true;
                break;
              case 'Multiple':
                filterN.value = true;
                filterC.value = true;
            }
          } else {
            notFound.value = true;
          }
        }
      })
    } catch (error) {
      console.error("Hubo un error en la solicitud: ", error);
    } finally {
      setFiltered(tmp.value);
      load = false;
    }
  }

  /*LOCAL STORAGE*/
  const setLocalStorage = (key, data) => {
    window.localStorage.setItem(key, JSON.stringify(data))
  }

  const getLocalStorage = (key) => {
    return JSON.parse(localStorage.getItem(key))
  }

  const removeLocalStorage = (key) => {
    localStorage.removeItem(key)
  }

  /*SESSION STORAGE */
  const setSessionStorage = (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data))
  }

  const getSessionStorage = (key) => {
    return JSON.parse(sessionStorage.getItem(key))
  }

  const removeSessionStorage = (key) => {
    sessionStorage.removeItem(key)
  }

  /*ALERT */
  const getAlertMsg = () => {
    return alertMsg.value;
  }

  const setAlertMsg = (data) => {
    alertMsg.value = data;
  }

  const getAlertType = () => {
    return alertType.value;
  }

  const setAlertType = (data) => {
    alertType.value = data;
  }

  const setAlertState = () => {
    alertState.value = 'inactive-alert';
    alertState.value = 'active-alert';
    setTimeout(() => { alertState.value = 'inactive-alert' }, 4000)
  }

  const getAlertState = () => {
    return alertState.value;
  }

  /**
   * Function to struct the message alert of store administrator 
   * @param {*} dataSMS Data to structure
   */
  const structSMS = async (dataSMS) => {
    var sms = ref('');
    if (dataSMS['type'] == 'local') {
      sms.value = '*`NÚMERO DE PEDIDO: ' + dataSMS['orderNum'] + '`*' + '%0A %0A*TIPO DE ENTREGA:* ' + dataSMS['type'] + '%0A*NOMBRE:* ' + dataSMS['name'] + ' ' + dataSMS['lastname'] + '%0A*TELEFONO:* ' + dataSMS['phone']
    } else {
      sms.value = '*`NÚMERO DE PEDIDO: ' + dataSMS['orderNum'] + '`*' + '%0A %0A*TIPO DE ENTREGA:* ' + dataSMS['type'] + '%0A*NOMBRE:* ' + dataSMS['name'] + ' ' + dataSMS['lastname'] + '%0A*TELEFONO:* ' + dataSMS['phone'] + '%0A %0A %0A*_DATOS DEL LUGAR DE ENTREGA_*' + '%0A*DEPARTAMENTO:* ' + dataSMS['department'] + '%0A*CIUDAD:* ' + dataSMS['city'] + '%0A*DIRECCIÓN:* ' + dataSMS['address']
    }
    window.open(SMS_URL + "?text=" + sms.value, "_blank");
  }


  /*SUBMENU*/
  submenu.value = getSessionStorage('submenu');

  const setSubMenu = (value) => {
    setLocalStorage('submenu', value);
    submenu.value = value
  }

  const getSubMenu = () => {
    return submenu.value;
  }

  const getConfiguration = async (page) => {
    var lng = getLng().split('-');
    try {
      await axios.get('configuration.php', {
        params: {
          "page": page,
          "lng": lng[0]
        }
      }).then(response => {
        if (response.status == 200) {
          setConfig(response['data']);
          setSessionStorage('configuration-' + page, config.value)
        }
      })
    } catch (error) {
      console.log(error)
    } finally {
      return getConfig();
    }
  }

  return {
    dark,
    i18n,
    isMovil,
    load,
    route,
    filterC,
    filterN,
    notFound,
    STORAGE_URL,
    darkMode,
    langFunction,
    setIsPP,
    getIsPP,
    validChar,
    validNum,
    getToday,
    filterData,
    getFiltered,
    getLng,
    getIndexSup,
    setIsLive,
    getIsLive,
    setLocalStorage,
    setSessionStorage,
    getLocalStorage,
    getSessionStorage,
    removeLocalStorage,
    removeSessionStorage,
    getAlertMsg,
    setAlertMsg,
    setAlertType,
    getAlertType,
    setAlertState,
    getAlertState,
    structSMS,
    setSubMenu,
    getSubMenu,
    getConfiguration
  }
})
